<template>
  <tr
    :id="item_id ? `table-row-${item[item_id]}` : null"
    :class="[`data-table-row data-table-row-${index}`, {'can-expand': can_expand, 'table-expanded': isExpanded }]"
    data-qa="data-table-row"
    @click="expandItem">
    <slot
      :loaded="loaded"
      name="row">
      <td
        v-for="(header, td_index) in headers"
        :key="header.value + index"
        class="text-start main__light_green table-row__td "
        :class="[ header.value + '-td' , header.cellClass || '', td_index + '-td_index' ]"
        :data-qa="'td' + header.value"
        :style="`width: ${header.width}; max-width: ${header.width}; min-width: ${header.width};`">
        <slot
          v-if="!wait_load || loaded "
          :header="header"
          :item="item"
          :item_index="index"
          :loaded="loaded"
          :name="`item.${header.value}`">
          <template v-if="header.value == 'data-table-select'">
            <div @click.stop>
              <sCheckbox
                class="mx-auto"
                :value="isSelected"
                @input="select"/>
            </div>
          </template>
          <span v-else>
            {{ item[header.value] }}
          </span>
        </slot>
        <span v-else>
          {{ item[header.value] }}
        </span>
      </td>
    </slot>
  </tr>
</template>
<script>
export default {
  name: 'tableTr',
  data() {
    return {
      loaded: false,
      observer: null
    }
  },
  props: {
    /**
     * заголовки - з них формуються комірки
     */
    headers: {
      type: Array,
      required: true
    },
    /**
     * об'єкт рядка
     */
    item: {
      type: Object,
      required: true
    },
    /**
     * унікальний код рядка
     */
    item_id: {
      type: String,
    },
    /**
     * індекс рядка
     */
    index: {
      type: Number,
      required: true
    },
    /**
     * чи потрібно використовувати IntersectionObserver
     */
    wait_load: {
      type: Boolean,
      default: false
    },
    /**
     * тільки з wait_load
     * Отступы вокруг root.  Могут иметь значения как свойство css margin: "10px 20px 30px 40px" (top, right, bottom, left). Значения можно задавать в процентах.
     */
    root_margin: {
      type: String,
      default: '200px'
    },
    /**
     * признак можливого рогортання
     */
    can_expand: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Function
    },
    isExpanded: {
      type: Boolean
    },
    isSelected: {
      type: Boolean
    },
    select: {
      type: Function
    },
  },
  mounted() {
    if ( this.wait_load ) {
      let options = {
        root: document.querySelector('.main_container'), //todo
        rootMargin: '200px',
        threshold: 0.2
      }

      this.observer = new IntersectionObserver(elements => { //https://developer.mozilla.org/ru/docs/Web/API/Intersection_Observer_API
        elements.forEach(element => {
          if ( element.isIntersecting && !this.loaded ) {
            this.observer.unobserve(element.target)
            this.observer = null
          }
          this.loaded ||= element.isIntersecting
        })
      }, options)
      this.observer.observe(this.$el)
    }
  },
  beforeDestroy() {
    if ( this.observer && !this.loaded ) {
      this.observer.unobserve( this.$el )
    }
  },
  methods: {
    expandItem() {
      if ( this.can_expand ) {
        this.expand(!this.isExpanded)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.can-expand {
  cursor: pointer;
}
</style>
